import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LazyImgModule } from '@core-mkt/services/lazy-load/lazy-load.module';
import { QueryParamModule } from '@core-mkt/services/query-param/query-param.module';
import { SliderComponent } from './slider/slider.component';

@NgModule({
  exports: [SliderComponent],
  imports: [CommonModule, QueryParamModule, LazyImgModule, SliderComponent],
})
export class SliderModule {}
